<template>
  <div class="menu-main-wrapper">
    <div class="menu-component">
      <div class="menu-wrapper md-grid-12">
        <div class="grid-wrapper">
          <div class="menu-containers md-grid-12" style="opacity: 1;">
            <ul class="menu-categories">
              <li
                class="category-link"
                v-for="item in menuList"
                :key="item.id"
                @mouseleave="mouseL(null, true)"
                @mouseover="mouseO(item)"
              >
                <div class="button-component menu content uppercase">
                  <div class="link-container">
                    <a href="#">{{ item.name }}</a>
                  </div>
                </div>
              </li>
              <li class="category-link">
                <div class="button-component menu content uppercase">
                  <div class="link-container">
                    <router-link to="/shop">店铺</router-link>
                  </div>
                </div>
              </li>
            </ul>
            <div class="logo-container">
              <div class="logo">
                <router-link to="/">
                  <img src="../assets/img/logo.png" />
                </router-link>
              </div>
            </div>
            <ul class="menu-actions">
              <li class="action-link">
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/locator"
                      ><p class="icon-container">
                        <svg
                          class="picker-icon"
                          width="25px"
                          height="35px"
                          viewBox="0 0 25 35"
                        >
                          <defs>
                            <polygon
                              points="0.00611725325 0.120238156 9.98492391 0.120238156 9.98492391 15.7149808 0.00611725325 15.7149808"
                            ></polygon>
                          </defs>
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g transform="translate(-708.000000, -299.000000)">
                              <g transform="translate(709.000000, 300.000000)">
                                <g transform="translate(4.140000, 3.154930)">
                                  <g transform="translate(0.000000, 0.245227)">
                                    <path
                                      d="M9.98507311,0.377489336 C9.33679347,0.210106128 8.65941957,0.12020161 7.96488753,0.12020161 C3.57352031,0.122028937 0.00798226948,3.61551385 0.00611725325,7.91740849 C0.00798226948,12.2203995 3.57389331,15.7131535 7.96488753,15.7149808 L7.96600654,15.7149808 C8.66053858,15.7149808 9.33716647,15.6258072 9.98507311,15.4598859 L9.98507311,13.392082 C9.3520866,13.6172087 8.67172868,13.7392742 7.96488753,13.7392742 C6.32479225,13.7389088 4.84546138,13.0876492 3.76561698,12.0314539 C2.68763759,10.9741621 2.02369181,9.52436038 2.02294581,7.91740849 C2.02369181,6.31118753 2.68763759,4.86138581 3.76561698,3.80372859 C4.84546138,2.74753324 6.32479225,2.09663914 7.96488753,2.09627368 C8.67060967,2.09627368 9.35096759,2.21870463 9.98507311,2.44456232 L9.98507311,0.377489336 Z"
                                      fill="#5F4F46"
                                      mask="url(#mask-2)"
                                    ></path>
                                  </g>
                                  <path
                                    d="M6.60909533,3.40939129 C6.54120874,3.44447598 6.28570151,3.56288681 6.24914719,3.6202649 C6.22154495,3.6637553 6.17193552,3.70943849 6.21856093,3.83296583 C6.25698026,3.93419978 6.52143956,3.96599528 6.54381976,3.97805564 C6.54605778,3.97586285 6.85714249,4.02264244 6.87355463,4.01825685 C6.91682301,4.00656195 7.20440851,3.94662561 7.21709062,3.9382199 C7.23126474,3.94662561 7.51922325,3.83515862 7.5251913,3.82602199 C7.58337981,3.80299766 7.90267059,3.57969823 7.89894056,3.58554567 C7.9727952,3.46421112 7.99815942,3.43570481 8.03322172,3.35895705 C8.04329281,3.33702912 8.14400369,3.12615551 8.14400369,3.12615551 C8.14810672,3.099842 8.15892382,3.08485791 8.16601088,3.05671707 C8.13542461,3.05781346 8.02426965,3.09582188 8.02165862,3.09947653 C7.96906517,3.11409515 7.69565379,3.17512789 7.69155075,3.17439696 C7.68931273,3.17330057 7.46625679,3.20838526 7.47632788,3.20619246 C7.45133666,3.21130898 7.39165614,3.22300388 7.38606109,3.22519667 C7.34726875,3.24127715 6.9500203,3.32971981 6.94256023,3.3425111 C6.94256023,3.33629819 6.59604021,3.41596967 6.60909533,3.40939129"
                                    fill="#5F4F46"
                                  ></path>
                                  <path
                                    d="M5.74544361,4.51952936 C5.72716645,4.51148912 5.3194739,4.60102817 5.30641879,4.60797201 C5.30567278,4.59993177 5.05165757,4.7501381 5.06956173,4.73625041 C5.03636444,4.76219846 5.00988121,4.8572195 5.0095082,4.84625553 C5.01398424,4.95662612 5.09194192,5.08198079 5.09194192,5.08198079 C5.11991717,5.07686428 5.31611687,5.12291293 5.34782215,5.12583666 C5.35826624,5.12693305 5.92187415,5.1338769 5.92523118,5.13424236 C5.93754028,5.13460783 6.61603319,5.02314085 6.63431035,5.01948619 C6.66079358,5.01400421 7.07370817,4.93944924 7.08116824,4.93616005 C7.10578645,4.92775434 7.40866509,4.82286574 7.43589432,4.8031306 C7.45379848,4.80239967 7.63209403,4.72419005 7.63470506,4.72821017 C7.60672981,4.75415822 7.40307004,4.99426907 7.40866509,4.99755826 C7.39523697,5.00011652 6.9729973,5.45694842 6.96964027,5.46535412 C6.90138067,5.52053942 6.33329673,6.05411908 6.30159145,6.06910316 C6.26242611,6.1005332 5.89277989,6.3326038 5.80027509,6.37901793 C5.78311694,6.3983876 5.31425186,6.590257 5.32021991,6.57636931 C5.30343476,6.57271465 5.27844355,6.60706841 5.26016639,6.6220525 C5.25382533,6.6527516 5.30194275,6.75033089 5.30641879,6.77152789 C5.32208493,6.76787324 5.4914284,6.86033602 5.53581579,6.86764533 C5.54029182,6.86874172 6.27137819,6.88116755 6.32136062,6.88116755 C6.32546366,6.88299488 6.88086549,6.97436126 6.88534153,6.971803 C6.88944457,6.97728498 7.31205725,7.01602433 7.32212833,7.01712072 C7.32212833,7.01712072 8.24083533,7.04855076 8.61906062,7.00104024 C8.62353666,7.00067478 8.78504707,6.92977446 8.85330666,6.87824383 C8.84174356,6.88738046 9.03607825,6.71086062 9.0304832,6.71890086 C9.06256148,6.67614139 9.22593691,6.5149711 9.25652317,6.44699451 C9.25838819,6.44333986 9.33000481,6.15425663 9.30314858,6.16266234 C9.29755353,6.16448967 9.02861819,6.23538998 9.02265014,6.23465905 C9.01034103,6.24306475 8.82421241,6.26243442 8.79922119,6.26682001 C8.79250713,6.26791641 8.54110294,6.32492903 8.52618281,6.32565996 C8.53028585,6.32237077 8.27552463,6.31725425 8.22442319,6.31213774 C8.16063963,6.28143863 7.71228973,6.26316536 7.71154372,6.26937827 C7.70482967,6.27595665 7.52877213,6.25622151 7.47692468,6.25366325 C7.42656924,6.25073953 7.22328247,6.2383137 7.2150764,6.22113682 C7.21992544,6.18751399 7.62127694,5.88235028 7.65708525,5.86882806 C7.67797343,5.8461692 7.78390635,5.76942144 7.81822265,5.7485899 C7.81822265,5.7485899 8.21286009,5.38641357 8.22143916,5.37983519 C8.22405019,5.38531718 8.41167082,5.11560362 8.41167082,5.11560362 C8.44859814,5.06188019 8.53289687,4.91532852 8.53177786,4.91240479 C8.54893601,4.87476184 8.71827949,4.51952936 8.72051751,4.3886927 C8.72051751,4.38138339 8.66009098,4.05867734 8.66419402,4.06525572 C8.61048155,3.9731584 8.50939767,3.93368813 8.44971715,3.92637882 C8.44598712,3.92601335 8.32849109,3.96658003 8.22740721,4.0060503 C8.21882814,4.00970496 8.0532147,4.08279806 8.07969793,4.07110316 C8.10618116,4.05867734 8.01218434,4.10472599 7.92527458,4.11788275 C7.84209486,4.13067404 7.42955327,4.1990161 7.4220932,4.1990161 C7.40307004,4.20047796 7.12182559,4.23592811 7.10354843,4.24725755 C7.10168342,4.24323742 6.3075595,4.39234736 6.30494848,4.39417468 C6.30159145,4.39636748 5.88681184,4.50198701 5.86816168,4.4957741 L5.74544361,4.51952936 Z"
                                    fill="#5F4F46"
                                  ></path>
                                  <path
                                    d="M7.35875725,10.8122243 C7.37106636,10.8129553 7.3990416,10.8787391 7.3990416,10.8787391 C7.41545375,10.8886066 7.5359338,11.0815724 7.53854482,11.0921709 C7.55271894,11.0983838 7.63440665,11.1798826 7.65342982,11.1806136 C7.65342982,11.1842682 8.04844026,11.4631184 8.05739233,11.4700623 C8.10812078,11.5055124 8.26888518,11.6173449 8.27932927,11.6257506 C8.32558167,11.6615662 8.62547628,11.88048 8.59936605,11.8669578 C8.68851383,11.9133719 8.73849626,11.9415128 8.80638285,11.9897542 C8.81906496,11.9985254 9.08427027,12.1867401 9.09284935,12.1951459 C9.10403944,12.2225558 9.27860496,12.2174393 9.29725513,12.2057444 C9.28904906,12.2108609 9.32784139,12.1684669 9.33380944,12.1326513 C9.33380944,12.1326513 9.26256582,11.9850032 9.24316966,11.9681918 C9.1913222,11.8932713 9.10851548,11.7843626 9.04846196,11.7178479 C9.03764487,11.7050566 8.96602824,11.5943205 8.95931419,11.5943205 C8.94887009,11.5559467 8.77654259,11.3527478 8.7657255,11.3373983 C8.76274147,11.3333782 8.71387805,11.2686908 8.71126703,11.271249 C8.65568954,11.2010796 8.31066154,10.8294012 8.30805052,10.8111279 C8.30879652,10.8169754 8.16034123,10.6327808 8.15773021,10.6272988 C8.1573572,10.6338772 8.05217029,10.5308159 8.04620224,10.5256994 C8.03650415,10.5304504 7.65566784,10.0743494 7.64559675,10.0717912 C7.63366065,10.0516906 7.52287868,9.9614206 7.51989466,9.96215153 C7.50087149,9.95411129 7.41992979,9.82400556 7.41843777,9.81779265 C7.41172371,9.80902147 7.3871055,9.70559473 7.3871055,9.69682356 C7.38300246,9.69645809 7.39643058,9.54844456 7.39493857,9.55063735 C7.43746094,9.49508659 7.49415743,9.48704635 7.55085393,9.46694575 C7.61389147,9.44501782 7.69968222,9.43076466 7.71049931,9.42784094 C7.82016227,9.39896916 8.3058125,9.28969497 8.34311282,9.26191959 C8.37854813,9.25936133 8.51767834,9.1621475 8.53670151,9.14716342 C8.53670151,9.14716342 8.67881574,8.97173997 8.67284769,8.97649102 C8.6739667,8.96625798 9.04249391,8.62747145 9.06562011,8.61066003 C9.07531819,8.58544291 9.02197873,8.53975972 9.01153464,8.53318134 C9.0189947,8.53537414 9.05368401,8.4721486 9.04920797,8.46630115 C9.052938,8.44766241 9.17528306,8.3226732 9.17752108,8.3142675 C9.16633099,8.29964888 9.168196,8.27150803 9.16409297,8.25762034 C9.13126868,8.25433115 9.03466084,8.18562363 9.02496276,8.19110562 C9.00146355,8.18964375 8.83212008,8.28941584 8.81458893,8.29489782 C8.81421592,8.29635969 8.53222547,8.41440505 8.49567115,8.43158193 C8.48634607,8.43596751 8.41398344,8.45789545 8.28828134,8.49042188 C8.27410722,8.49371107 8.05813834,8.56168765 8.04359121,8.56534231 C8.00964792,8.57228615 7.8582086,8.60481258 7.8582086,8.60481258 C7.8347094,8.60737084 7.40202563,8.68338767 7.36957435,8.6958135 C7.37330438,8.69508257 7.32481396,8.62454772 7.31287785,8.59604141 C7.28639462,8.53391227 7.28863264,8.51783179 7.27333951,8.47726512 C7.23939621,8.38662967 7.21701602,8.33985008 7.19799285,8.30037981 C7.18381873,8.2718735 7.1685256,8.1965876 7.1808347,8.19220201 C7.19911186,8.18525817 7.59300329,7.9846176 7.62023253,7.97986654 C7.63403365,7.96378606 7.87312873,7.78726622 7.88804886,7.77410946 C7.89737394,7.74414128 7.89513592,7.72586801 7.89364391,7.70722927 C7.89065988,7.68091575 7.86380365,7.66373887 7.86380365,7.64838932 C7.86268464,7.62682685 7.91826212,7.43495745 7.91826212,7.43495745 C7.904088,7.42106976 7.7664498,7.41924244 7.71311034,7.44043944 C7.68849212,7.43897757 7.40762068,7.4959902 7.37218537,7.49160461 L6.57619644,7.63011604 C6.53777711,7.63779082 6.47772358,7.64838932 6.45086735,7.65642956 C6.45235936,7.65058211 5.97678022,7.77374399 5.97081217,7.77410946 C5.87196631,7.78653528 5.69367076,7.86182118 5.69367076,7.86182118 C5.69367076,7.86182118 5.61384806,7.96451699 5.62317315,8.03176265 C5.62764919,8.06611641 5.64406133,8.08036956 5.6873297,8.14980801 C5.72351102,8.20974436 5.76901742,8.25981313 5.92157574,8.36652907 C5.98946233,8.41330865 6.10919638,8.43267832 6.13978264,8.43706391 C6.17447194,8.44108403 6.36358459,8.43998763 6.37179066,8.44254589 C6.39715488,8.44583508 6.49637375,8.41586691 6.5139049,8.41330865 C6.53442008,8.409654 6.57321242,8.38662967 6.57321242,8.38662967 C6.57955347,8.37712757 6.64520204,8.41769424 6.65415412,8.41330865 C6.66161419,8.42134889 6.71569966,8.68265674 6.71569966,8.68265674 C6.71271563,8.69764083 6.72763576,8.71847236 6.72577074,8.72139609 C6.72614375,8.72103062 6.71458065,8.85771472 6.71905669,8.86319671 C6.71569966,8.86612043 6.61163175,8.90193605 6.61163175,8.90193605 C6.62058383,8.89316488 6.52919803,8.90485978 6.51539691,8.90705257 C6.40349594,8.92386398 6.03086569,9.01632676 6.03086569,9.01632676 C6.02676266,9.01669223 5.49597904,9.15995471 5.48851897,9.16032018 C5.46949581,9.16251297 5.20727453,9.22318025 5.20727453,9.22318025 C5.18004529,9.23158595 5.14796701,9.23085502 5.11775375,9.22427664 C5.11700774,9.22829676 5.01965389,9.17859345 4.9976467,9.18188264 C4.94132321,9.18882649 4.74698852,9.26667064 4.74139347,9.2893295 C4.74064746,9.29298416 4.6294925,9.36936645 4.57055798,9.46694575 C4.55339983,9.49545206 4.52505159,9.61020823 4.52094855,9.6200758 C4.52952763,9.6211722 4.5146075,9.73483197 4.5261706,9.74287222 C4.53400367,9.73921756 4.57093099,9.80865601 4.57839105,9.81267613 C4.57839105,9.80902147 4.8831347,9.82985301 5.04725613,9.83679685 C5.06516029,9.83752778 5.20615552,9.83643139 5.22405967,9.83679685 C5.26658204,9.83716232 5.46576578,9.84081697 5.55192953,9.84300977 C5.58922985,9.8437407 5.90106056,9.82912208 5.93313884,9.82290916 C5.92082974,9.82510196 6.25578665,9.76260735 6.26026269,9.76151096 C6.26548474,9.75602897 6.41282102,9.72898453 6.4337092,9.73117732 C6.44079626,9.73154278 6.42550313,9.76187642 6.42923316,9.75456711 C6.41207501,9.78782447 6.36843363,9.83058394 6.3531405,9.85799385 C6.34978347,9.8638413 6.12933855,10.0666747 6.12933855,10.0666747 C6.11106139,10.0926227 5.90106056,10.301669 5.88875146,10.3305408 C5.88576743,10.3305408 5.85816519,10.3637981 5.85667318,10.36526 C5.81937285,10.4102123 5.65114839,10.6126802 5.64406133,10.6137766 C5.64406133,10.6225477 5.10357962,11.2562649 5.10469863,11.255534 C5.10208761,11.2573613 5.07373936,11.3037755 5.07150134,11.3056028 C5.0666523,11.3260688 4.95810836,11.4207244 4.95437832,11.4364394 C4.90439589,11.4799298 4.69327605,11.7017674 4.687308,11.69592 C4.687308,11.69592 4.61942141,11.7843626 4.61345336,11.8000776 C4.59181917,11.8574557 4.66268979,11.9510149 4.65149969,11.9491876 C4.72684634,11.9619789 4.84061233,11.9301834 4.85031042,11.9257978 C4.92192704,11.8932713 4.99391667,11.8541665 4.99540868,11.8538011 C4.9976467,11.8527047 5.24047181,11.7134623 5.24345584,11.711635 C5.29940633,11.679474 5.31096943,11.6721647 5.34491272,11.6476785 C5.39489516,11.6118629 5.74328019,11.3706556 5.74775623,11.3695592 C5.79177061,11.3490932 6.13232258,11.0581826 6.13791763,11.0541625 C6.15992482,11.0475841 6.54449117,10.7047775 6.55232423,10.7022192 C6.55232423,10.7022192 6.62319485,10.6313189 6.62580587,10.6313189 C6.62729789,10.640821 6.6168538,10.8356141 6.6175998,10.8407306 C6.61834581,10.8469436 6.52957104,11.6188067 6.53852311,11.6451202 C6.52882503,11.6608353 6.49898477,11.9301834 6.48928669,11.9173921 C6.49786576,11.9356653 6.45385138,12.3113639 6.46951751,12.3387738 C6.54411816,12.4677831 6.62282185,12.5131009 6.62282185,12.5131009 C6.62058383,12.5258922 6.66534422,12.5617078 6.69406547,12.5639006 C6.71346164,12.5653624 6.93390656,12.5503783 6.93800959,12.5463582 C6.985008,12.5397798 7.04021248,12.4619357 7.0424505,12.458281 C7.0543866,12.4597429 7.15136745,12.2773756 7.16031953,12.2795684 C7.16404956,12.2543513 7.25767337,11.9159302 7.24424526,11.8932713 C7.25618136,11.8918095 7.3408531,11.6085737 7.33898808,11.6184413 C7.34943217,11.5438863 7.30467178,11.4090295 7.30728281,11.3966037 C7.30765581,11.3940454 7.33637706,11.1056931 7.33675006,11.0921709 C7.33712306,11.085958 7.3524162,10.8147826 7.35875725,10.8122243"
                                    fill="#5F4F46"
                                  ></path>
                                </g>
                                <path
                                  d="M11.3071189,0 C5.0723619,0 -3.55271368e-15,4.84808156 -3.55271368e-15,10.8069911 C-3.55271368e-15,12.580737 0.461097421,14.3415824 1.32712459,15.8882522 L1.34047711,15.9125273 C1.4935957,16.1851018 1.66500145,16.4597571 1.85019513,16.7294186 L11.3071189,31.8312967 L20.7638975,16.7295573 C20.9490912,16.4601732 21.1203518,16.1853792 21.2737607,15.9125273 L21.2875486,15.8876973 C22.1554626,14.3329821 22.6140927,12.5762981 22.6140927,10.8069911 C22.6140927,4.84808156 17.5418759,0 11.3071189,0"
                                  stroke="#5F4F46"
                                  stroke-width="1.90817308"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </p>
                      <p style="margin-left: 5px">店铺地址</p></router-link
                    >
                  </div>
                </div>
              </li>
              <li class="action-link">
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/contact"
                      ><p class="icon-container">
                        <svg
                          width="17px"
                          height="17px"
                          viewBox="0 0 17 17"
                          class="icon-component contact-icon grey-type"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              transform="translate(-1203.000000, -7731.000000)"
                              fill="#5F4F46"
                            >
                              <g transform="translate(409.000000, 7125.000000)">
                                <g
                                  transform="translate(318.000000, 507.000000)"
                                >
                                  <g
                                    transform="translate(311.000000, 98.000000)"
                                  >
                                    <g
                                      transform="translate(165.000000, 1.000000)"
                                    >
                                      <path
                                        d="M1.83449479,1.77083333 L15.1655052,1.77083333 C14.7180156,5.05050521 11.9004427,7.58642708 8.5,7.58642708 C5.09946875,7.58642708 2.28189583,5.05050521 1.83449479,1.77083333 L1.83449479,1.77083333 Z M15.2291667,15.2291667 L1.77083333,15.2291667 L1.77083333,6.04394271 C3.32659896,8.05773438 5.76415104,9.35726042 8.5,9.35726042 C11.2357604,9.35726042 13.6733125,8.05773438 15.2291667,6.04394271 L15.2291667,15.2291667 Z M0,17 L17,17 L17,0 L0,0 L0,17 Z"
                                      ></path>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </p>
                      <p style="margin-left: 5px">联系我们</p></router-link
                    >
                  </div>
                </div>
              </li>
              <li class="action-link">
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/jion"
                      ><p class="icon-container">
                        <Icon type="md-heart-outline" size="20" />
                      </p>
                      <p style="margin-left: 5px">加盟代理</p></router-link
                    >
                  </div>
                </div>
              </li>
            </ul>
            <div class="menu-burger" @click="showMeu()">
              <span class="line01" :class="{ active: mShow }"></span
              ><span class="line02" :class="{ active: mShow }"></span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="menu-categories-banner md-grid-12"
        :class="{ active: activeIndex }"
        @mouseleave="mouseL(null, true)"
      >
        <div
          class="menu-categories-container grid-wrapper"
          :class="{ active: activeIndex }"
        >
          <div class="menu-category-container" @mouseover="mouseO()">
            <div
              class="category-wrapper grid-wrapper"
              :class="{ active: 1 == activeIndex }"
              v-if="1 == activeIndex"
            >
              <div class="img-wrapper md-grid-2 pad-2-right">
                <div class="img-container">
                  <div class="cover-img-component">
                    <div class="img-wrapper grid-12">
                      <img
                        alt=""
                        style="margin-top: 0px"
                        src="../assets/img/nature-1.jpg"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <ul class="column-container pad-3-right">
                <li
                  class="link-container column-title"
                  style="transition-delay: .2s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div style="font-size: 20px">
                      23区
                    </div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .4s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div style="font-w">以东京市内的23个区命名</div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .6s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>自由的搭配展现与众不同的气质与个性</div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .8s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>奔放，内敛</div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: 1s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>坚强，温柔</div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: 1.2s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>永远保持自己风格</div>
                  </div>
                </li>
              </ul>
              <div class="img-wrapper md-grid-2 pad-2-right">
                <div class="img-container">
                  <div class="cover-img-component">
                    <div class="img-wrapper grid-12">
                      <img
                        alt=""
                        style="margin-top: 0px"
                        src="../assets/img/nature-2.jpg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ul class="column-container pad-3-right">
                <li class="link-container column-title">
                  <div class="button-component content menu-link uppercase">
                    <div style="font-size: 20px;transition-delay: .2s">
                      ICB
                    </div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .4s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>
                      为女性彰显自我及社会价值的品牌
                    </div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .6s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>
                      多样中显露清新，传统中不乏新颖
                    </div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: .8s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>
                      彰显出个性，召唤当代女性内在信心的ICB
                    </div>
                  </div>
                </li>
                <li
                  class="link-container column-title"
                  style="transition-delay: 1s"
                >
                  <div class="button-component content menu-link uppercase">
                    <div>
                      在基础风格中用时尚洗炼优雅的风格
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="category-wrapper grid-wrapper"
              :class="{ active: 2 == activeIndex }"
              v-if="2 == activeIndex"
            >
              <div class="img-wrapper md-grid-4 pad-2-right">
                <div class="img-container">
                  <div class="cover-img-component">
                    <div class="img-wrapper grid-12">
                      <img alt="" src="../assets/img/23.jpg" />
                    </div>
                  </div>
                </div>
              </div>
              <ul class="column-container pad-3-right">
                <li
                  class="link-container column-title"
                  :style="'transition-delay:' + 0.2 * (index + 1) + 's'"
                  v-for="(item, index) in twoList"
                  :key="index"
                >
                  <div class="button-component content menu-link uppercase">
                    <div class="link-container">
                      <router-link
                        :to="{
                          name: 'pro',
                          query: { id: item.id, type: encodeURI(item.classify) }
                        }"
                        >{{ item.name }}</router-link
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="category-wrapper grid-wrapper"
              :class="{ active: 3 == activeIndex }"
              v-if="3 == activeIndex"
            >
              <div class="img-wrapper md-grid-4 pad-2-right">
                <div class="img-container">
                  <div class="cover-img-component">
                    <div class="img-wrapper grid-12">
                      <img alt="" src="../assets/img/icb.jpg" />
                    </div>
                  </div>
                </div>
              </div>
              <ul class="column-container pad-3-right">
                <li
                  class="link-container column-title"
                  :style="'transition-delay:' + 0.2 * (index + 1) + 's'"
                  v-for="(item, index) in IBCList"
                  :key="index"
                >
                  <div class="button-component content menu-link uppercase">
                    <div class="link-container">
                      <router-link
                        :to="{
                          name: 'pro',
                          query: { id: item.id, type: encodeURI(item.classify) }
                        }"
                        >{{ item.name }}</router-link
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-mobile" :class="{ active: mShow }">
        <div class="menu-mobile-categories grid-wrapper">
          <ul class="menu-categories">
            <li
              class="category-link"
              style="transform: matrix(1, 0, 0, 1, 0, 0);"
              @click="subLable(1)"
            >
              <div class="button-component title content uppercase">
                <div class="link-container">
                  <a href="#">品牌介绍</a>
                </div>
              </div>
              <div class="category-link-arrow">
                <svg
                  style="width:11px;vertical-align:middle"
                  viewBox="0 0 9 16"
                >
                  <g
                    transform="translate(-1153.000000, -2431.000000)"
                    stroke="#5F4F46"
                    stroke-width="1.15"
                  >
                    <g transform="translate(620.000000, 1869.000000)">
                      <g transform="translate(533.000000, 1.000000)">
                        <polygon
                          transform="translate(4.500000, 569.000000) rotate(90.000000) translate(-4.500000, -569.000000)"
                          points="-2 566.373593 4.5 572 11 566.373593 10.5684 566.001125 4.5 571.253938 -1.5684 566"
                        ></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </li>
            <li
              class="category-link"
              style="transform: matrix(1, 0, 0, 1, 0, 0);"
              @click="subLable(2)"
            >
              <div class="button-component title content uppercase">
                <div class="link-container">
                  <a href="#">23区</a>
                </div>
              </div>
              <div class="category-link-arrow">
                <svg
                  style="width:11px;vertical-align:middle"
                  viewBox="0 0 9 16"
                >
                  <g
                    transform="translate(-1153.000000, -2431.000000)"
                    stroke="#5F4F46"
                    stroke-width="1.15"
                  >
                    <g transform="translate(620.000000, 1869.000000)">
                      <g transform="translate(533.000000, 1.000000)">
                        <polygon
                          transform="translate(4.500000, 569.000000) rotate(90.000000) translate(-4.500000, -569.000000)"
                          points="-2 566.373593 4.5 572 11 566.373593 10.5684 566.001125 4.5 571.253938 -1.5684 566"
                        ></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </li>
            <li
              class="category-link"
              style="transform: matrix(1, 0, 0, 1, 0, 0);"
              @click="subLable(3)"
            >
              <div class="button-component title content uppercase">
                <div class="link-container">
                  <a href="#">ICB</a>
                </div>
              </div>
              <div class="category-link-arrow">
                <svg
                  style="width:11px;vertical-align:middle"
                  viewBox="0 0 9 16"
                >
                  <g
                    transform="translate(-1153.000000, -2431.000000)"
                    stroke="#5F4F46"
                    stroke-width="1.15"
                  >
                    <g transform="translate(620.000000, 1869.000000)">
                      <g transform="translate(533.000000, 1.000000)">
                        <polygon
                          transform="translate(4.500000, 569.000000) rotate(90.000000) translate(-4.500000, -569.000000)"
                          points="-2 566.373593 4.5 572 11 566.373593 10.5684 566.001125 4.5 571.253938 -1.5684 566"
                        ></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </li>
          </ul>
        </div>
        <div class="menu-mobile-actions">
          <div class="grid-wrapper">
            <ul class="menu-actions">
              <li
                class="action-link"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/shop">店铺</router-link>
                  </div>
                </div>
                <div class="icon-container">
                  <Icon type="ios-cart-outline" size="24" />
                </div>
              </li>
              <li
                class="action-link"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/locator">店铺地址</router-link>
                  </div>
                </div>
                <div class="icon-container">
                  <Icon type="ios-pin-outline" size="24" />
                </div>
              </li>
              <li
                class="action-link"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/contact">联系我们</router-link>
                  </div>
                </div>
                <div class="icon-container">
                  <Icon type="ios-mail-outline" size="24" />
                </div>
              </li>
              <li
                class="action-link"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <div class="button-component menu content">
                  <div class="link-container">
                    <router-link to="/jion">代理加盟</router-link>
                  </div>
                </div>
                <div class="icon-container">
                  <Icon type="md-heart-outline" size="24" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="menu-mobile-category" :class="{ active: subShow }">
          <div class="menu-mobile-category-wrapper">
            <div class="grid-12">
              <div
                class="menu-categories-title"
                style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                @click="subLableClose"
              >
                <svg
                  viewBox="0 0 9 16"
                  style="width: 8px; vertical-align: middle;"
                >
                  <g
                    transform="translate(-1153.000000, -2431.000000)"
                    stroke="#5F4F46"
                    stroke-width="1.15"
                  >
                    <g transform="translate(620.000000, 1869.000000)">
                      <g transform="translate(533.000000, 1.000000)">
                        <polygon
                          transform="translate(4.500000, 569.000000) rotate(90.000000) translate(-4.500000, -569.000000)"
                          points="-2 566.373593 4.5 572 11 566.373593 10.5684 566.001125 4.5 571.253938 -1.5684 566"
                        ></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
                <div class="menu-categories-title-text">
                  <h2 class="title-component default uppercase">
                    {{ mNowLabel }}
                  </h2>
                </div>
              </div>
              <ul class="menu-categories">
                <li
                  class="menu-category-item"
                  style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                >
                  <ul v-if="mNowLabel == '品牌介绍'">
                    <li
                      style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                      class="pipai_m"
                    >
                      <img
                        alt=""
                        src="../assets/img/nature-1.jpg"
                      />
                      <h3>23区</h3>
                      <p>
                        以东京市内的23个区命名<br>
                        自由的搭配展现与众不同的气质与个性<br>
                        奔放，内敛<br>
                        坚强，温柔<br>
                        永远保持自己风格
                      </p>
                    </li>
                    <li
                      style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                      class="pipai_m"
                    >
                      <img
                        alt=""
                        src="../assets/img/nature-2.jpg"
                      />
                      <h3>ICB</h3>
                      <p>
                        为女性彰显自我及社会价值的品牌<br>
                        多样中显露清新，传统中不乏新颖<br>
                        彰显出个性，召唤当代女性内在信心的ICB<br>
                        在基础风格中用时尚洗炼优雅的风格
                      </p>
                    </li>
                  </ul>
                  <ul v-else>
                    <li
                      style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                      v-for="(item, index) in mNowMenu"
                      :key="index"
                    >
                      <div class="button-component default content zorba">
                        <div class="link-container">
                          <router-link
                            :to="{
                              name: 'pro',
                              query: { id: item.id, type: item.classify }
                            }"
                            >{{ item.name }}</router-link
                          >
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Header",
  data() {
    return {
      activeIndex: null,
      time: null,
      menuList: [
        {
          id: 1,
          name: "品牌介绍"
        },
        {
          id: 2,
          name: "23区"
        },
        {
          id: 3,
          name: "ICB"
        }
      ],
      url: this.$api,
      nowList: [],
      twoList: [],
      IBCList: [],
      twoOne: [],
      IBCOne: [],
      nowOne: [{ name: "" }],
      mShow: false,
      subShow: false,
      mNowLabel: "",
      mNowMenu: []
    };
  },
  async mounted() {
    // setup 第一参数props 第一参数context
    let { data } = await axios.get(this.$api + "/Api/Product_All");
    let list = data.data;
    this.twoList = list.filter(e => e.classify == "23区");
    this.IBCList = list.filter(e => e.classify == "ICB");
    let twoOne = await axios.get(
      this.$api + "/Api/Product_Get/" + this.twoList[0].id
    );
    twoOne.data.data[0].title = "23区";
    let IBCOne = await axios.get(
      this.$api + "/Api/Product_Get/" + this.IBCList[0].id
    );
    IBCOne.data.data[0].title = "ICB";
    this.twoOne = twoOne.data.data;
    this.IBCOne = IBCOne.data.data;
  },
  methods: {
    mouseO(item) {
      if (item) {
        this.activeIndex = item.id;
        if (item.id == 2) {
          this.nowList = this.twoList;
          this.nowOne = this.twoOne;
        } else if (item.id == 3) {
          this.nowList = this.IBCList;
          this.nowOne = this.IBCOne;
        }
      }

      this.mouseL(item, false);
    },
    mouseL(item, flag) {
      if (flag) {
        this.time = setTimeout(() => {
          this.activeIndex = null;
        }, 700);
      } else {
        clearTimeout(this.time);
      }
    },
    showMeu() {
      this.mShow = !this.mShow;
    },
    subLable(v) {
      this.mNowLabel = this.menuList.filter(e => e.id == v)[0].name;
      this.subShow = true;
      if (v == 2) {
        this.mNowMenu = this.twoList;
      }
      if (v == 3) {
        this.mNowMenu = this.IBCList;
      }
    },
    subLableClose() {
      this.subShow = false;
    }
  }
};
</script>

<style scoped>
.menu-categories-banner {
  transform: matrix(1, 0, 0, 1, 0, -390);
  transition: all 1s;
}
.menu-categories-banner.active {
  z-index: 0;
  transform: translate(0%, 100%) matrix(1, 0, 0, 1, 0, 0);
}
.menu-categories-containe {
  visibility: hidden;
  opacity: 0;
  transition: all 1s;
  transform: translate(0%, 0) matrix(1, 0, 0, 1, 0, 0);
}
.menu-categories-container.active {
  z-index: 0;
  visibility: inherit;
  opacity: 1;
  transform: translate(0%, -100%) matrix(1, 0, 0, 1, 0, 0);
}

.menu-categories-container .menu-category-container {
  visibility: hidden;
  opacity: 0;
  transition: all 1s;
}
.menu-categories-container.active .menu-category-container {
  visibility: inherit;
  opacity: 1;
}
.menu-categories-container .column-title {
  visibility: hidden;
  opacity: 0;
  transform: translate(0%, -100%) matrix(1, 0, 0, 1, 0, 20);
  transition: all 1s;
}
.menu-categories-container.active .column-title {
  visibility: inherit;
  opacity: 1;
  transform: translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0);
}
.menu-mobile {
  transform: translate(100%, 0%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}
.menu-mobile.active {
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.line01,
.line01 {
  transform: matrix(1, 0, 0, 1, 0, 0);
  transition: all 0.5s;
}
.line01.active {
  transform: matrix(0.7071, 0.7071, -0.7071, 0.7071, 0, 5);
}
.line02.active {
  transform: matrix(0.7071, -0.7071, 0.7071, 0.7071, 0, -3);
}
.menu-mobile-category {
  transition: all 0.5s;
  transform: translate(100%, 0%) matrix(1, 0, 0, 1, 0, 0);
}
.menu-mobile-category.active {
  transform: translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0);
}
</style>